module.exports = __webpack_public_path__ + "img/Advantage4.3df5c072.png";